// import {
//   Checkbox,
//   Grid,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TextField,
//   useTheme
// } from "@mui/material";
// import _ from "lodash";
// import moment from "moment";
// import React, { memo, useEffect, useRef, useState } from "react";
// import { useStyle } from "../style";

// const BillingTable = ({data, setData, setPostData,postData}) => {
//   const theme = useTheme();
//   const outlet_id = localStorage.getItem('outlet_id')
//   const classes = useStyle();
//   const[active, setActive] = useState(null)
//   const qtyRef = useRef(null)
//   console.log(postData,'Data enna varuthu')

//   function getSelectedRow(e){
//     setActive(e)
//     const arr=[...data]
//   } 

//   function handleQtyChange(e, idx){
//     const arr=[...data]
//     const isChecked = e.target.checked;
//     arr[idx].retQty = isChecked ? 1 : 0;
//     console.log(Number(arr[idx].gst_per) + 100)

//     arr[idx].gst_amt = parseFloat( arr[idx].mrp - ( arr[idx].mrp * 100 / (100 + Number(arr[idx].gst_per)))).toFixed(0)
//     // arr[idx].gst_amt = parseFloat(( arr[idx].mrp - arr[idx].mrp * arr[idx].dis_per / 100) * (arr[idx].gst_per / 100 * arr[idx].retQty)).toFixed(0)
//     arr[idx].cess_amt = parseFloat(( arr[idx].mrp - arr[idx].mrp * arr[idx].dis_per / 100) * (arr[idx].cess_per / 100 * arr[idx].retQty)).toFixed(0)
//     // arr[idx].totalAmt = arr[idx].retQty * ( arr[idx].mrp - arr[idx].mrp * arr[idx].dis_per / 100)
//     arr[idx].totalAmt = arr[idx].retQty * ( arr[idx].mrp - arr[idx].mrp * arr[idx].dis_per / 100)
//     setData(arr)
//   }

//   useEffect(() => {
//     if(data.length > 0){
//       let arr = []
//       data.map(val => {
//         const obj = {
//           docdate: moment().format('YYYY/MM/DD'), 
//           prodid:val.prodid,
//           dis_per:val.dis_per,
//           dis_amt: val.dis_amt,
//           outletid: outlet_id,
//           mrp: val.mrp,
//           rate: val.rate,
//           qty: val.retQty,
//           gst_per: val.gst_per,
//           gst_amt: val.gst_amt,
//           cess_per: val.cess_per,
//           cess_amt: val.cess_amt,
//           barcode: val.barcode,
//           head_id:val.head_id,
//           type_id:val.type_id,
//           subcat_id:val.subcat_id,
//           cat_id:val.cat_id,
//           uom_id:val.uom_id,
//           company_id: val.company_id,
//         }
//         arr.push(obj)
//       }) 
//       setPostData((prevState) => ({...prevState , outlet_sales_return_details : arr , }))
//     }
//   },[data])

//   console.log(data,"responseee")
//   console.log(postData)

//   return (
//     <Grid className="w-full h-full">
//       <TableContainer className={classes.tblRoot}>
//         <Table stickyHeader  className={classes.table}>
//           <TableHead className={classes.tblHeader}>
//             <TableRow className={classes.tablrow}>
//               <TableCell className={classes.tblCell} sx={{borderLeft:'0.5px solid  #ccc'}}>Sno</TableCell>
//               <TableCell className={classes.tblCell}>Product Code</TableCell>
//               <TableCell className={classes.tblCell}>Barcode</TableCell>
//               <TableCell className={classes.tblCell}>Description</TableCell>
//               <TableCell className={classes.tblCell}>MRP</TableCell>
//               <TableCell className={classes.tblCell}>GST%</TableCell>
//               <TableCell className={classes.tblCell}>Rate</TableCell>
//               <TableCell className={classes.tblCell}>Dis%</TableCell>
//               <TableCell className={classes.tblCell}>Return Qty</TableCell>
//               <TableCell className={classes.tblCell}>GST</TableCell>
//               <TableCell className={classes.tblCell}>Amount</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {data.length > 0 ? _.map(data, (val, idx) => (
//                <TableRow className={classes.tablrow} key={idx} onClick={() => getSelectedRow(idx)}>
//                <TableCell padding="checkbox" className={classes.tblContentCell}>{idx + 1}</TableCell>
//                <TableCell>{val.pro_code}</TableCell>
//                <TableCell>{val.barcode}</TableCell>
//                <TableCell variant="body" className={classes.tblContentCell}>{val.pro_name}</TableCell>
//                <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{val.mrp}</TableCell>
//                <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{parseFloat(val.gst_per)}%</TableCell>
//                <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{val.rate}</TableCell>
//                <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{parseFloat(val.dis_per)}%</TableCell>
//                <TableCell className={classes.tblContentCell} sx={{width:100}}>
//                 <Checkbox 
//                   checked={val.retQty > 0}
//                   onChange={(e) => handleQtyChange(e, idx)}
//                 />
//                </TableCell>
//                <TableCell className={classes.tblContentCell} sx={{width:100}}>{val.gst_amt}</TableCell>
//                <TableCell className={classes.tblContentCell} sx={{width:100}}>{val.totalAmt}</TableCell>
//              </TableRow>
//             )) :
//             <TableRow className={classes.tablrow}>
//               <TableCell padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{data.length + 1}</TableCell>
//               <TableCell padding="checkbox" sx={{ width: 120 }} className={classes.tblContentCell}></TableCell>
//               <TableCell variant="body" className={classes.tblContentCell}></TableCell>
//               <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}></TableCell>
//               <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}></TableCell>
//               <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}></TableCell>
//               <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}></TableCell>
//               <TableCell padding="checkbox" sx={{ width: 120 }} className={classes.tblContentCell}></TableCell>
//               <TableCell padding="checkbox" sx={{ width: 120 }} className={classes.tblContentCell}></TableCell>
//               <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell>
//               <TableCell className={classes.tblContentCell} sx={{width:100}}></TableCell>
//             </TableRow>
//             }  
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </Grid>
//   );
// };

// export default memo(BillingTable);
import {
  Checkbox,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme
} from "@mui/material";
import _ from "lodash";
import moment from "moment";
import React, { memo, useEffect, useRef, useState } from "react";
import { useStyle } from "../style";

const BillingTable = ({ data, setData, setPostData, postData }) => {
  const theme = useTheme();
  const outlet_id = localStorage.getItem('outlet_id');
  const classes = useStyle();
  const [active, setActive] = useState(null);
  const qtyRef = useRef(null);
  console.log(postData, 'Data enna varuthu');

  function getSelectedRow(e) {
    setActive(e);
  } 

  function handleQtyChange(e, idx) {
    const arr = [...data];
    const isChecked = e.target.checked;
    arr[idx].retQty = isChecked ? 1 : 0;
    
    arr[idx].gst_amt = parseFloat(arr[idx].mrp - (arr[idx].mrp * 100 / (100 + Number(arr[idx].gst_per)))).toFixed(0);
    arr[idx].cess_amt = parseFloat((arr[idx].mrp - arr[idx].mrp * arr[idx].dis_per / 100) * (arr[idx].cess_per / 100 * arr[idx].retQty)).toFixed(0);
    arr[idx].totalAmt = arr[idx].retQty * (arr[idx].mrp - arr[idx].mrp * arr[idx].dis_per / 100);
    setData(arr);

    // Filter only rows where retQty > 0
    const selectedRows = arr.filter(row => row.retQty > 0).map(val => ({
      docdate: moment().format('YYYY/MM/DD'), 
      prodid: val.prodid,
      dis_per: val.dis_per,
      dis_amt: val.dis_amt,
      outletid: outlet_id,
      mrp: val.mrp,
      rate: val.rate,
      qty: val.retQty,
      gst_per: val.gst_per,
      gst_amt: val.gst_amt,
      cess_per: val.cess_per,
      cess_amt: val.cess_amt,
      barcode: val.barcode,
      head_id: val.head_id,
      type_id: val.type_id,
      subcat_id: val.subcat_id,
      cat_id: val.cat_id,
      uom_id: val.uom_id,
      company_id: val.company_id,
    }));
    
    // Update the payload with only selected rows
    setPostData((prevState) => ({ ...prevState, outlet_sales_return_details: selectedRows }));
  }

  return (
    <Grid className="w-full h-full">
      <TableContainer className={classes.tblRoot}>
        <Table stickyHeader className={classes.table}>
          <TableHead className={classes.tblHeader}>
            <TableRow className={classes.tablrow}>
              <TableCell className={classes.tblCell} sx={{ borderLeft: '0.5px solid #ccc' }}>Sno</TableCell>
              <TableCell className={classes.tblCell}>Product Code</TableCell>
              <TableCell className={classes.tblCell}>Barcode</TableCell>
              <TableCell className={classes.tblCell}>Description</TableCell>
              <TableCell className={classes.tblCell}>MRP</TableCell>
              <TableCell className={classes.tblCell}>GST%</TableCell>
              <TableCell className={classes.tblCell}>Rate</TableCell>
              <TableCell className={classes.tblCell}>Dis%</TableCell>
              <TableCell className={classes.tblCell}>Return Qty</TableCell>
              <TableCell className={classes.tblCell}>GST</TableCell>
              <TableCell className={classes.tblCell}>Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? _.map(data, (val, idx) => (
              <TableRow className={classes.tablrow} key={idx} onClick={() => getSelectedRow(idx)}>
                <TableCell padding="checkbox" className={classes.tblContentCell}>{idx + 1}</TableCell>
                <TableCell>{val.pro_code}</TableCell>
                <TableCell>{val.barcode}</TableCell>
                <TableCell variant="body" className={classes.tblContentCell}>{val.pro_name}</TableCell>
                <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}>{Math.round(val.mrp)}</TableCell>
                <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}>{parseFloat(val.gst_per).toFixed(0)}%</TableCell>
                <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}>{Math.round(val.rate)}</TableCell>
                <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}>{parseFloat(val.dis_per).toFixed(0)}%</TableCell>
                <TableCell className={classes.tblContentCell} sx={{ width: 100 }}>
                  <Checkbox
                    checked={val.retQty > 0}
                    onChange={(e) => handleQtyChange(e, idx)}
                  />
                </TableCell>
                <TableCell className={classes.tblContentCell} sx={{ width: 100 }}>{Math.round(val.gst_amt)}</TableCell>
                <TableCell className={classes.tblContentCell} sx={{ width: 100 }}>{val.totalAmt}</TableCell>
              </TableRow>
            )) :
              <TableRow className={classes.tablrow}>
                <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ borderLeft: '0.5px solid #ccc' }}>{data.length + 1}</TableCell>
                <TableCell padding="checkbox" sx={{ width: 120 }} className={classes.tblContentCell}></TableCell>
                <TableCell variant="body" className={classes.tblContentCell}></TableCell>
                <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}></TableCell>
                <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}></TableCell>
                <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}></TableCell>
                <TableCell padding="checkbox" className={classes.tblContentCell} sx={{ width: 100 }}></TableCell>
                <TableCell padding="checkbox" sx={{ width: 120 }} className={classes.tblContentCell}></TableCell>
                <TableCell padding="checkbox" sx={{ width: 120 }} className={classes.tblContentCell}></TableCell>
                <TableCell className={classes.tblContentCell} sx={{ width: 100 }}></TableCell>
                <TableCell className={classes.tblContentCell} sx={{ width: 100 }}></TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default memo(BillingTable);
